import Vue from 'vue';
import Router from 'vue-router';
import { NAME_ROUTES } from './features/core/utils';
import store from './store';

Vue.use(Router);

export const router = new Router({
    mode: 'history',
    routes: [
        {
            path: NAME_ROUTES.LOGIN.path,
            name: NAME_ROUTES.LOGIN.name,
            component: () => import('./features/auth/views/LoginPage.vue'),
            meta: { requiresAuth: false }
        },
        {
            path: NAME_ROUTES.DELETE_ACCOUNT.path,
            name: NAME_ROUTES.DELETE_ACCOUNT.name,
            component: () => import('./features/auth/views/DeleteAccountPage.vue'),
            meta: { requiresAuth: false }
        },
        {
            path: NAME_ROUTES.HOME.path,
            component: () => import('./features/home/views/HomePage.vue'),
            meta: { requiresAuth: true },
            children: [
                {
                    path: NAME_ROUTES.ITEM_DETAIL.path,
                    component: () => import('./features/item/PageItemDetail.vue'),
                    name: NAME_ROUTES.ITEM_DETAIL.name,
                    meta: { requiresAuth: true },
                    props: route => ({
                        id: route.params.id
                    })
                },
                {
                    path: NAME_ROUTES.ITEM_WITH_SINISTERS.path,
                    component: () => import('./features/item_with_sinisters/PageItemWithSinisters.vue'),
                    name: NAME_ROUTES.ITEM_WITH_SINISTERS.name,
                    meta: { requiresAuth: true }
                },
                {
                    path: NAME_ROUTES.CLAIM_DETAIL.path,
                    component: () => import('./features/item_with_sinisters/PageClaimDetail.vue'),
                    name: NAME_ROUTES.CLAIM_DETAIL.name,
                    meta: { requiresAuth: true },
                    props: route => ({
                        id: route.params.id
                    })
                },
            ]
        },
        {
            path: '*',
            name: 'Not Found',
            component: () => import('./features/home/views/PageNotFound.vue')
          }
    ]
});

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
    document.title = `Gestión de Polígonos`;
    
    const isAuthenticated = store.getters['auth/isAuthenticated'];
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    
    if (requiresAuth && !isAuthenticated) {
        // Redirect to login if route requires auth and user is not authenticated
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
    } else if (to.path === '/login' && isAuthenticated) {
        // Redirect to claims page if already authenticated and trying to access login
        next('/claims/');
    } else if (to.path === '/' && isAuthenticated) {
        // Redirect to claims page if authenticated user lands on root path
        next('/claims/');
    } else {
        next();
    }
});

export default router;
